import Icon from '@ant-design/icons';
import { Button, Col, Form, FormInstance, Input, Row } from 'antd';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link, RouteComponentProps } from 'react-router-dom';
import coachApi from '../../../../apis/CoachApi';
import LayoutComponent from '../../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../../context/CustomContext';
import { Coach } from '../../../../model/Entities';
import { ReactComponent as SaveSvg } from '../../../../resources/images/ico-save.svg';
import { ReactComponent as DeleteSvg } from '../../../../resources/images/ico-delete.svg';
import styles from './CoachPage.module.scss';

class CoachPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            if (this.props.match.params.id === 'new') {
                await this.new();
            } else {
                await this.get(+this.props.match.params.id);
            }
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    new = async () => {
        const coach: Coach = {
            firstName: '',
        };

        this.setState({ coach });
        this.formRef.current!.setFieldsValue(coach);
    };

    get = async (id: number) => {
        const coach = await coachApi.get(id);

        this.setState({ coach });
        this.formRef.current!.setFieldsValue(coach);
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        const { coach, loading } = this.state;

        return (
            <>
                {this.renderToolbar()}
                <Form ref={this.formRef} colon={false} layout="vertical">
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <Form.Item
                                label={<FormattedMessage id="coach.edit.firstName" />}
                                name="firstName"
                                rules={[{ required: true, message: <FormattedMessage id="status.mandatory" /> }]}
                            >
                                <Input maxLength={100} placeholder={coach?.firstName} size="large" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={8}>
                            <Form.Item
                                label={<FormattedMessage id="coach.edit.lastName" />}
                                name="lastName"
                                rules={[{ required: true, message: <FormattedMessage id="status.mandatory" /> }]}
                            >
                                <Input maxLength={100} placeholder={coach?.lastName} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className={styles.buttons}>
                        <Link to="/admin/coaches">
                            <Button size="large" className={styles.back}>
                                <FormattedMessage id="coach.edit.back" />
                            </Button>
                        </Link>
                        {this.props.match.params.id !== 'new' && (
                            <Button size="large" icon={<Icon component={DeleteSvg} />} className={styles.delete}>
                                <FormattedMessage id="coach.edit.delete" />
                            </Button>
                        )}
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className={styles.save}
                            icon={<Icon component={SaveSvg} />}
                            loading={loading}
                        >
                            <FormattedMessage id="coach.edit.save" />
                        </Button>
                    </div>
                </Form>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        if (this.props.match.params.id === 'new') {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="coach.addtitle" />
                    </h1>
                </div>
            );
        } else {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="coach.edittitle" />
                    </h1>
                </div>
            );
        }
    };

    render() {
        return <LayoutComponent page="edit-coach" content={this.renderContent} />;
    }
}
export default injectIntl(CoachPage);

type ParamsType = { id: string };
interface Props extends RouteComponentProps<ParamsType>, WrappedComponentProps {}

interface State {
    coach?: Coach;
    loading?: boolean;
}
